import React, { createContext, useContext, useEffect, useState } from "react";

const ReleasesContext = createContext({
  releases: null,
  loading: true,
  error: null,
});

export function ReleasesProvider({ children }) {
  const [releases, setReleases] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReleases = async () => {
      try {
        const response = await fetch(
          "/api/releases?playlistId=2OQ9MeW9wjpRQm4qL08wsE",
        );

        if (!response.ok) {
          const text = await response.text();
          throw new Error(text || `API error: ${response.status}`);
        }

        const data = await response.json();
        setReleases(data);
      } catch (err) {
        console.error("Error fetching releases:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReleases();
  }, []);

  return (
    <ReleasesContext.Provider value={{ releases, loading, error }}>
      {children}
    </ReleasesContext.Provider>
  );
}

export function useReleases() {
  return useContext(ReleasesContext);
}
